const B2B_ACCESS_FEATURE_NAMES = ["leitura-b2b", "cadastro-b2b"];

function hasFeatureName(userdata, featureName) {
  return Boolean(
    userdata?.profilePermissions?.some(
      (permission) => permission.featureName === featureName
    )
  );
}

export function hasB2BAccess(userdata) {
  return Boolean(
    userdata?.profilePermissions?.some(
      (permission) =>
        permission.featureCategory === "feature" &&
        B2B_ACCESS_FEATURE_NAMES.includes(permission.featureName)
    )
  );
}

export function hasB2BWriteAccess(userdata) {
  return hasFeatureName(userdata, "cadastro-b2b");
}

const B2B_REDIRECT_PROFILES = ["Leitura B2B", "Cadastro B2B"];

export function shouldRedirectToB2B(userdata) {
  return B2B_REDIRECT_PROFILES.includes(userdata?.profile);
}
